import { get } from 'lodash'
import { required, ageByConfig, maxLength } from 'utils/validation'

const validate = (values, props, { leaderMinAge } = {}) => {
  let errors = {}

  errors = {
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName')),
    birthDate:
      required(get(values, 'birthDate')) ||
      ageByConfig(get(values, 'birthDate'), {
        configuration: get(props, 'configuration.values'),
        leaderMinAge
      }),
    gender: {
      value: required(get(values, 'gender.value'))
    },
    line1: required(get(values, 'line1')),
    zipCode: required(get(values, 'zipCode')),
    stateOrProvinceOrRegion:
      required(get(values, 'stateOrProvinceOrRegion')) ||
      maxLength(70)(get(values, 'stateOrProvinceOrRegion')),
    city: required(get(values, 'city')),
    addressCountryId: required(get(values, 'addressCountryId')),
    minAgeConfirmation: required(get(values, 'minAgeConfirmation'))
  }

  console.log('XXX validate', values, errors)

  return errors
}

export default validate
